import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PageCompanyView } from "./pageCompanyView";
import { PageCompanyAdd } from "./pageCompanyAdd";
import { PageCompanyUpdate } from "./pageCompanyUpdate";
import { PageSingleCompany } from "./pageSingleCompany";
import { RedirectRoute } from "../../../components/redirectRoute";

export function PageCompany(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Company.List()}
          exact
          component={PageCompanyView}
        />
        <Route
          path={AppRouteUi.Company.Add()}
          exact
          component={PageCompanyAdd}
        />
        <Route
          path={AppRouteUi.Company.Update()}
          exact
          component={PageCompanyUpdate}
        />
        <Route
          path={AppRouteUi.Company.ById()}
          exact
          component={PageSingleCompany}
        />
        <RedirectRoute
          from={AppRouteUi.Company.Root()}
          to={AppRouteUi.Company.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
